import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const { refresh } = useAuth();
  const sid = params.get("session_id");
  const nav = useNavigate();

  useEffect(() => {
    if (!sid) { nav("/dashboard"); return; }
    let tries = 0;
    const tick = async () => {
      tries++;
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); await refresh(); return; }
      } catch {}
      if (tries < 10) setTimeout(tick, 2000);
      else setStatus("timeout");
    };
    tick();
  }, [sid, nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-card p-10 max-w-md text-center">
        {status === "checking" && (<><Loader2 className="w-12 h-12 mx-auto animate-spin text-[color:var(--gold)] mb-4" /><h1 className="font-heading text-2xl font-bold mb-2">Confirming your subscription...</h1></>)}
        {status === "paid" && (<><CheckCircle2 className="w-16 h-16 mx-auto text-[color:var(--emerald)] mb-4" /><h1 className="font-heading text-2xl font-bold mb-2 gold-gradient-text">You're in.</h1><p className="text-[color:var(--text-secondary)] mb-2">Your 7-day free trial has started. Your card will be charged automatically only after the trial ends.</p><p className="text-xs text-[color:var(--text-muted)] mb-6">Cancel anytime from Settings — no charge if you cancel before the trial ends.</p><Link to="/dashboard" className="gold-btn px-6 py-3 rounded-full inline-block">Go to dashboard</Link></>)}
        {status === "timeout" && (<><h1 className="font-heading text-xl font-bold mb-2">Still processing...</h1><Link to="/dashboard" className="text-[color:var(--gold)] hover:underline">Back to dashboard</Link></>)}
      </div>
    </div>
  );
}
